import { cellValueExcel, RowExportTypeExcel } from "types"
import { APPROVAL, excel } from "utils"
import { PropsWithChildren } from "react"
import { TableSorting } from "components"
import moment from "moment"
import { BuildFile } from "../../ItemBuild/RegisterItemsBuild"

export function ExportExcelBuildItem(props: PropsWithChildren<ExportBuildItemType>) {
  const activeCols = props.activeColumns.filter(col => col.isActive !== false)

  const columns = [
    { header: "NO", key: "no", width: 5 },
    ...activeCols
      .map(col => renderColumn(col.value as string))
      .filter((col): col is NonNullable<typeof col> => col !== undefined),
  ]

  const dataMap = props.data.map((item, index) => {
    const row: Record<string, any> = { no: index + 1 }

    activeCols.forEach(col => {
      const colMeta = renderColumn(col.value as string)
      if (colMeta) {
        row[colMeta.key] = renderCellValue(col.value as string, item)
      }
    })

    return row
  })

  excel({
    dataList: dataMap,
    column: columns,
    module: props.module,
    title: props.title,
    fileName: props.fileName
  })
}

function numberFormat(value: number): cellValueExcel {
  return {
    text: value,
    style: {
      alignment: { horizontal: "right" },
      numFmt: "#,##0",
    },
  }
}

function renderColumn(title: string): { header: string; key: string | number; width: number } | undefined {
  const map: Record<string, { header: string; key: keyof RowExportTypeExcel; width: number }> = {
    "trx_code": { header: "TRANSFER ID#", key: "trx_code", width: 20 },
    "transaction_date": { header: "DATE", key: "transaction_date", width: 15 },
    "barcode": { header: "BARCODE", key: "product_barcode", width: 30 },
    "description": { header: "DESCRIPTION", key: "product_name", width: 30 },
    "group_name": { header: "GROUP", key: "mr_product_group_name", width: 20 },
    "location_name": { header: "LOCATION", key: "location_name", width: 15 },
    "employee_name": { header: "TRADER", key: "employee_name", width: 30 },
    "approve_status": { header: "APPROVED", key: "approve_status", width: 15 },
    "qty": { header: "QTY BUILD", key: "qty", width: 15 },
    "unit": { header: "UNIT", key: "mr_unit_name", width: 15 },
    "cac": { header: "CAC", key: "cac", width: 15 },
    "avg_price": { header: "AVERAGE", key: "avg_price", width: 15 },
  }
  return map[title]
}


function renderCellValue(title: string, item: any): any {
  switch (title) {
    case "trx_code":
      return item.trx_code
    case "transaction_date":
      return moment(item.transaction_date).format("DD/MM/YYYY")
    case "barcode":
      return item.product_barcode
    case "description":
      return item.product_name
    case "group_name":
      return item.mr_product_group_name
    case "location_name":
      return item.location_name
    case "employee_name":
      return item.employee_name
    case "approve_status":
      return Object.keys(APPROVAL).find(key => APPROVAL[key as keyof typeof APPROVAL] === item.approve_status) ?? '-'
    case "qty":
      return numberFormat(Number(item.qty_build_unit))
    case "unit":
      return item.mr_unit_name
    case "cac":
      return numberFormat(Number(item.component_at_cost))
    case "avg_price":
      return numberFormat(Number(item.avg_price))
    default:
      return item
  }
}



type ExportBuildItemType = {
  data: BuildFile[],
  filter: {
    dateFrom: string | undefined,
    dateTo: string | undefined
  },
  module?: string,
  title: string,
  fileName: string,
  activeColumns: TableSorting[]
}

